module.exports = __webpack_public_path__ + "img/3.e82b3602.png";